// extracted by mini-css-extract-plugin
module.exports = {"dialog":"SurveyEditor_dialog__3ZuMI","variants":"SurveyEditor_variants__NIEYX","variant":"SurveyEditor_variant__3cM0H"};